export function parseGcodeText(content) {
  // Layer previews repeat this field; the final estimate includes purge and all layers.
  const estimates = [...content.matchAll(/estimated printing time \(normal mode\)[ \t]*=[ \t]*([^\r\n;]+)/gi)];
  const timeTotals = [...content.matchAll(/total estimated time:[ \t]*([^\r\n;]+)/gi)];
  const time = estimates.at(-1) || timeTotals.at(-1);
  let time_s = null;
  if (time) {
    const units = { d: 86400, h: 3600, m: 60, s: 1 };
    const parts = [...time[1].matchAll(/(\d+(?:\.\d+)?)\s*([dhms])/gi)];
    if (parts.length) time_s = parts.reduce((sum, m) => sum + Number(m[1]) * units[m[2].toLowerCase()], 0);
  }
  function list(label) {
    const match = content.match(new RegExp("^;[ \\t]*" + label + "[ \\t]*[=:][ \\t]*([^\\r\\n]*)", "im"));
    if (!match) return [];
    return match[1].split(/[,;]/).map(v => v.trim() !== "" && Number.isFinite(Number(v)) && Number(v) >= 0 ? Number(v) : null);
  }

  const grams = list("filament used \\[g\\]");
  const mm = list("filament used \\[mm\\]");
  const totals = list("total filament weight \\[g\\]");
  const lengths = list("total filament length \\[mm\\]");
  const activeIds = list("filament");
  const idsValid = activeIds.length > 0 && activeIds.every(id => Number.isInteger(id) && id > 0)
    && new Set(activeIds).size === activeIds.length;
  const mappedGrams = idsValid && totals.length === activeIds.length;
  const mappedLengths = idsValid && lengths.length === activeIds.length;
  const colors = content.match(/^;[ \t]*filament_colou?r[ \t]*=[ \t]*([^\r\n]*)/im)?.[1].split(/[;,]/) || [];
  const types = content.match(/^;[ \t]*filament_type[ \t]*=[ \t]*([^\r\n]*)/im)?.[1].split(/[;,]/) || [];
  const count = Math.max(grams.length, mm.length, colors.length, types.length, idsValid ? Math.max(...activeIds) : 0);
  const porExtrusor = Array.from({ length: count }, (_, i) => {
    const active = activeIds.indexOf(i + 1);
    return {
      extrusor: i, id: i + 1,
      filament_g: grams[i] ?? (mappedGrams ? (active < 0 ? 0 : totals[active]) : count === 1 ? totals[0] ?? null : null),
      filament_mm: mm[i] ?? (mappedLengths ? (active < 0 ? 0 : lengths[active]) : null),
      color: colors[i]?.trim() || null, type: types[i]?.trim() || null,
    };
  });
  const sum = values => values.length && values.every(Number.isFinite) ? values.reduce((a, b) => a + b, 0) : null;
  return { time_s, time_h: time_s == null ? null : time_s / 3600,
    filament_g: sum(totals) ?? sum(grams), filament_mm: sum(lengths) ?? sum(mm), porExtrusor };
}


export function extrairMetaGcode(cabecalho, rodape = "") {
  const text = cabecalho + "\n" + rodape;
  const stats = parseGcodeText(text);
  const number = key => {
    const value = text.match(new RegExp("^;[ \\t]*" + key + "[ \\t]*=[ \\t]*([\\d.]+)", "im"));
    return value ? Number(value[1]) : null;
  };
  return {
    horas: stats.time_h, peso_g: stats.filament_g,
    nozzleDiameter: number("nozzle_diameter"), layerHeight: number("layer_height"),
    printerProfile: text.match(/^;[ \t]*printer_settings_id[ \t]*=[ \t]*([^\r\n]+)/im)?.[1].trim() || null,
    materiais: stats.porExtrusor.map(f => ({ index: f.id, color: f.color, type: f.type })),
    pesos: Object.fromEntries(stats.porExtrusor.map(f => [f.id, f.filament_g])),
  };
}

export async function extrairMetaGcodeDeArquivo(file) {
  const headSize = 200000, tailSize = 20000;
  const head = await file.slice(0, headSize).text();
  const tail = file.size > headSize ? await file.slice(Math.max(headSize, file.size - tailSize)).text() : "";
  return extrairMetaGcode(head, tail);
}
